import './bootstrap';
import './calendar';

import 'lightslider';

var $loaderView =
    '<div class="loader">' +
    '<svg class="circular" viewBox="25 25 50 50">' +
    '<circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>' +
    '</svg>' +
    '</div>';

lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true
})

$(window).scroll(function() {
    if ($(window).scrollTop() >= 47) {
        $("#navbarMain").addClass('fixed-top');
        $("#navbarMain").removeClass('rounded-5');
    } else {
        $("#navbarMain").addClass('rounded-5');
        $("#navbarMain").removeClass('fixed-top');
    }
});

$(function() {
    AOS.init({ once: true });

    if ($(window).scrollTop() >= 47) {
        $("#navbarMain").addClass('fixed-top');
        $("#navbarMain").removeClass('rounded-5');
    } else {
        $("#navbarMain").addClass('rounded-5');
        $("#navbarMain").removeClass('fixed-top');
    }

    $('[data-bs-toggle="tooltip"]').each(function () {
        new bootstrap.Tooltip(this);
    });

    $('#primaryModal').on('shown.bs.modal', function(e) {
        let $input = $(this).find('.form-control:first');

        if ($input.length) {
            $input.get(0).focus();
        }
    });

    $(document).on('click', '.counter-input .plus', function() {
        let $container = $(this).closest('.counter-input');
        let $input = $container.find('.count');

        $input.val(parseInt($input.val()) + 1);

        $input.trigger('change');
    });

    $(document).on('click', '.counter-input .minus', function() {
        let $container = $(this).closest('.counter-input');
        let $input = $container.find('.count');
        let min = $input.attr('min');

        $input.val(parseInt($input.val()) - 1);

        if ($input.val() < min) {
            $input.val(min);
        }

        $input.trigger('change');
    });

    $(document).on('change', '#reservationModal form', function() {
        let validation = true;

        $(this).find('select, input').each(function() {
            if ($(this).attr('name') == 'phone' || ($(this).attr('name') == 'quantity_kid' && ($(this).val().trim() == '' || $(this).val() == '0' || $(this).val() == 0))) {
                return;
            }

            if ($(this).val() == 0 || $(this).val().trim() == '') {
                validation = false;
            }
        });

        $(this).find('[type="submit"]').prop('disabled', !validation);
    })

    $(document).on('submit', '.modal form', function() {
        let $form = $(this);
        let $modal = $form.closest('.modal');
        let formData = new FormData($form.get(0));
        let $submit = $form.find('[type="submit"]');
        let innerHtml = $submit.html();
        let width = $submit.outerWidth();

        if (!$submit.attr('disabled')) {
            $submit.attr('disabled', true);
            $submit.css({ 'width': width + 'px' }).html($loaderView);

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: formData,
                contentType: false,
                processData: false,
                beforeSend: function() {
                    $form.find('.invalid-feedback').remove();
                    $form.find('.is-invalid').removeClass('is-invalid');
                },
                success: function(data) {
                    if (data.status && data.status == 'success') {

                        if (data.sum) {
                            $modal.find('.modal-body .sum').html(data.sum);

                            innerHtml = 'Rezerwuj';
                            $form.attr('action', $form.attr('data-url-book'));
                        } else {
                            $modal.find('.modal-body').html(data.message);
                        }

                        if (data.url) {
                            window.location = data.url;
                        }
                    } else {
                        alert('Wystąpił nieoczekiwany błąd 22');
                    }
                },
                error: function(xhr) {
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        let $errorHtml = $('<ul></ul>');

                        $.each(xhr.responseJSON.errors, function(name, error) {
                            let $input, $element;

                            if (name.includes('.')) {
                                name = name.replace(/(\.([\d]+|[a-z\_]+))/g, '[$2]');
                            }

                            $input = $form.find('[name="' + name + '"]');
                            $element = $input;

                            if ($input.parent().hasClass('input-group') || $input.parent().hasClass('bootstrap-select')) {
                                $element = $input.parent();
                                $input.addClass('is-invalid');
                            }

                            if ($element.length) {
                                $element.addClass('is-invalid')
                                    .after('<div class="invalid-feedback">' + error[0] + '</div>');
                            } else if (error.length) {
                                $errorHtml.append('<li>' + error[0] + '<li>');
                            }
                        });

                        $('#primaryToast .toast-body').html('Popraw błędy formularza!' + ($errorHtml.children().length ? $errorHtml.html() : ''));
                        $('#primaryToast').toast('show');
                    } else {
                        alert('Wystąpił nieoczekiwany błąd 22');
                    }
                },
                complete: function() {
                    $submit.attr('disabled', false)
                        .removeAttr('style')
                        .html(innerHtml);
                }
            });
        }

        return false;
    });

    $('.input-group').on('click', '.button-plus', function(e) {
        incrementValue(e);
    });

    $('.input-group').on('click', '.button-minus', function(e) {
        decrementValue(e);
    });

    $('#checkAllCountries').on('change', function() {
        var checked = $(this).is(':checked');
        $('.country-checkbox, .location-checkbox')
            .prop('checked', checked)
            .trigger('change'); // <- wywołujemy ręcznie zdarzenie change
    });

    // Zaznacz/odznacz regiony po kliknięciu checkboxa kraju
    $('.country-checkbox').on('change', function() {
        var countryId = $(this).data('country-id');
        var checked = $(this).is(':checked');

        // Zaznacz/odznacz wszystkie regiony tego kraju
        $('.location-checkbox[data-parent-country="' + countryId + '"]').prop('checked', checked);

        updateCheckAllCountries();
    });

    // Po kliknięciu checkboxa regionu aktualizuj checkbox kraju i "Wszystkie"
    $('.location-checkbox').on('change', function() {
        var countryId = $(this).data('parent-country');

        // Sprawdź czy wszystkie regiony danego kraju są zaznaczone
        var allLocationsChecked = $('.location-checkbox[data-parent-country="' + countryId + '"]').length === $('.location-checkbox[data-parent-country="' + countryId + '"]:checked').length;

        // Ustaw checkbox kraju
        $('.country-checkbox[data-country-id="' + countryId + '"]').prop('checked', allLocationsChecked);

        updateCheckAllCountries();
    });

    $('.btn-map').on('click', function() {
        if ($(this).prev('.map').hasClass('active')) {
            $(this).prev('.map').removeClass('active');
            $(this).text('Wyświetl mapę');
        } else {
            $(this).prev('.map').addClass('active');
            $(this).text('Ukryj mapę');
        }
    });

    $('#searchSection').on('change', 'input[name="direction"]', function() {
        $('.search-direction').text($('#searchSection input[name="direction"]:checked').next('label').text());
    });

    $(document).on('click', '.btn-description-more', function() {
        if ($(this).hasClass('active')) {
            $(this).prev('div').addClass('description-truncate');
            $(this).removeClass('active').text('czytaj więcej');
        } else {
            $(this).prev('div').removeClass('description-truncate');
            $(this).addClass('active').text('ukryj');
        }
    });

    // Event show
    $('#hotelImageGallery').lightSlider({
        gallery:true,
        slideMargin: 0,
        thumbMargin: 10,
        galleryMargin: 15,
        item:1,
        loop:true,
        thumbItem:5,
        enableTouch: true,
        enableDrag: true,
        prevHtml: '<i class="bi bi-chevron-left"></i>',
        nextHtml: '<i class="bi bi-chevron-right"></i>'
    });
    
    $('#eventImageGallery').lightSlider({
        gallery:true,
        slideMargin: 0,
        thumbMargin: 10,
        galleryMargin: 15,
        item:1,
        loop:true,
        thumbItem:5,
        enableTouch: true,
        enableDrag: true,
        prevHtml: '<i class="bi bi-chevron-left"></i>',
        nextHtml: '<i class="bi bi-chevron-right"></i>'  
    });

    $('.room-modal').on('shown.bs.modal', function() {
        if($(this).find('.lSSlideOuter').length == 0) {
            $(this).find('.room-image-gallery').lightSlider({
                gallery:true,
                slideMargin: 0,
                thumbMargin: 10,
                galleryMargin: 15,
                item:1,
                loop:true,
                thumbItem:5,
                enableTouch: true,
                enableDrag: true,
                prevHtml: '<i class="bi bi-chevron-left"></i>',
                nextHtml: '<i class="bi bi-chevron-right"></i>'
            });
        }
    });

    $('.country-checkbox, .location-checkbox').on('change', function () {
        const selectedCountries = new Set();

        // Zaznaczone państwa
        $('.country-checkbox:checked').each(function () {
            const label = $('label[for="' + this.id + '"]').text().trim();
            selectedCountries.add(label);
        });

        // Zaznaczone regiony -> znajdź odpowiadające im kraje
        $('.location-checkbox:checked').each(function () {
            const parentId = $(this).data('parent-country');
            const countryCheckbox = $('.country-checkbox[data-country-id="' + parentId + '"]');
            const label = $('label[for="' + countryCheckbox.attr('id') + '"]').text().trim();
            selectedCountries.add(label);
        });

        // Aktualizacja wyświetlanego tekstu
        if (selectedCountries.size > 0) {
            $('.search-direction').text([...selectedCountries].join(', '));
        } else {
            $('.search-direction').text('Dokąd chcesz jechać?');
        }
    });

    $('.hotel-select').on('click', function() {
        let $btn =  $(this);

        $.get($(this).data('ajax'), function( data ) {
            $('#selectedHotel').html(data.view);

            $('.selected-hotel-name').text(data.data.name);
            $('#eventReservationForm input[name="hotel_id"]').val(data.data.id);

            $('#hotelImageGallery').lightSlider({
                gallery:true,
                slideMargin: 0,
                thumbMargin: 10,
                galleryMargin: 15,
                item:1,
                loop:true,
                thumbItem:5,
                enableTouch: true,
                enableDrag: true,
                prevHtml: '<i class="bi bi-chevron-left"></i>',
                nextHtml: '<i class="bi bi-chevron-right"></i>'
            });

            var element = document.getElementById('selectedHotelHeader');
            var headerOffset = 110;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

            $('.room-modal').on('shown.bs.modal', function() {
                if($(this).find('.lSSlideOuter').length == 0) {
                    $(this).find('.room-image-gallery').lightSlider({
                        gallery:true,
                        slideMargin: 0,
                        thumbMargin: 10,
                        galleryMargin: 15,
                        item:1,
                        loop:true,
                        thumbItem:5,
                        enableTouch: true,
                        enableDrag: true,
                        prevHtml: '<i class="bi bi-chevron-left"></i>',
                        nextHtml: '<i class="bi bi-chevron-right"></i>'
                    });
                }
            });

            $('.hotel-select').addClass('btn-danger')
                .removeClass('btn-light')
                .prop('disabled', false)
                .text('Wybierz hotel');

            $btn.addClass('btn-light')
                .removeClass('btn-danger')
                .prop('disabled', true)
                .text('Wybrany hotel');

        });

        return false;
    });

    $(".guest-counter").guestCounter();
});

function updateCheckAllCountries() {
    var allCountriesChecked = $('.country-checkbox').length === $('.country-checkbox:checked').length;
    $('#checkAllCountries').prop('checked', allCountriesChecked);
}

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

(function ($) {
    $.fn.guestCounter = function (options) {
        const settings = $.extend({
            maxPeople: 10,
            adultsInput: "#adultsQuantity",
            kidsInput: "#kidsQuantity",
            kidsAgeContainer: "#kidsAges",
            summaryText: ".search-quantity-text", // opcjonalne
            defaultChildAge: 12
        }, options);

        return this.each(function () {
            const $container = $(this);

            function updateButtons() {
                const adults = parseInt($container.find(settings.adultsInput).val());
                const kids = parseInt($container.find(settings.kidsInput).val());
                const total = adults + kids;

                $container.find(settings.adultsInput).siblings(".button-minus").prop("disabled", adults <= 1);
                $container.find(settings.adultsInput).siblings(".button-plus").prop("disabled", total >= settings.maxPeople);

                $container.find(settings.kidsInput).siblings(".button-minus").prop("disabled", kids <= 0);
                $container.find(settings.kidsInput).siblings(".button-plus").prop("disabled", total >= settings.maxPeople);
            }

            function updateSummaryText() {
                const adults = parseInt($container.find(settings.adultsInput).val());
                const kids = parseInt($container.find(settings.kidsInput).val());
                const total = adults + kids;

                const $summary = $container.find(settings.summaryText);
                if ($summary.length) {
                    $summary.text(`${total} ${getPersonWord(total)}`);
                }
            }

            function getPersonWord(count) {
                if (count === 1) return "osoba";
                if (count >= 2 && count <= 4) return "osoby";
                return "osób";
            }

            function renderKidsAgeSelects() {
                const kidsCount = parseInt($container.find(settings.kidsInput).val());
                const $ageContainer = $container.find(settings.kidsAgeContainer);
                $ageContainer.empty();

                if (kidsCount > 0) {
                    $ageContainer.append('<p class="fw-bold" style="font-size:14px;">Podaj wiek dzieci</p>');
                    for (let i = 0; i < kidsCount; i++) {
                        const $select = $('<select class="form-select mb-2" name="kidAge[]"></select>');
                        for (let age = 0; age <= 17; age++) {
                            const selected = (age === settings.defaultChildAge) ? ' selected' : '';
                            $select.append(`<option value="${age}"${selected}>${age} lat</option>`);
                        }
                        $ageContainer.append($select);
                    }
                    $ageContainer.show();
                } else {
                    $ageContainer.hide();
                }
            }

            $container.find(".button-plus").on("click", function () {
                const $input = $(this).siblings("input.quantity-field");
                const val = parseInt($input.val());
                const isAdult = $input.is(settings.adultsInput);

                const adults = parseInt($container.find(settings.adultsInput).val());
                const kids = parseInt($container.find(settings.kidsInput).val());
                const total = adults + kids;

                if (total < settings.maxPeople) {
                    $input.val(val + 1);
                    if (!isAdult) renderKidsAgeSelects();
                    updateButtons();
                    updateSummaryText();
                }
            });

            $container.find(".button-minus").on("click", function () {
                const $input = $(this).siblings("input.quantity-field");
                const val = parseInt($input.val());
                const isAdult = $input.is(settings.adultsInput);

                if (isAdult && val > 1) {
                    $input.val(val - 1);
                } else if (!isAdult && val > 0) {
                    $input.val(val - 1);
                    renderKidsAgeSelects();
                }
                updateButtons();
                updateSummaryText();
            });

            // Init
            updateButtons();
            renderKidsAgeSelects();
        });
    };
})(jQuery);